import { ExpenseInput } from "@/components/ExpenseInput";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useLanguage } from "@/contexts/LanguageContext";

interface ExpenseInputSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onExpenseAdded: () => void;
  pushUndo: (action: any) => void;
}

export const ExpenseInputSheet = ({ 
  open, 
  onOpenChange, 
  onExpenseAdded,
  pushUndo 
}: ExpenseInputSheetProps) => {
  const { t } = useLanguage();
  
  const handleExpenseAdded = () => {
    onExpenseAdded();
    // Don't auto-close anymore - let SuccessCard handle timing
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent 
        side="bottom" 
        className="h-auto max-h-[85vh] flex flex-col overflow-hidden rounded-t-2xl pb-safe"
      >
        {/* Drag handle indicator */}
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-10 h-1 bg-muted-foreground/30 rounded-full" />
        </div>
        
        <SheetHeader className="flex-shrink-0 pb-4 px-6">
          <SheetTitle className="text-center">{t('quickAdd.title')}</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto overflow-x-hidden px-6 pb-6">
          <ExpenseInput onExpenseAdded={handleExpenseAdded} pushUndo={pushUndo} />
        </div>
      </SheetContent>
    </Sheet>
  );
};
